/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Cancel_Subscription_QuestionInputs */

const en_mobile_faq_cancel_subscription_question = /** @type {(inputs: Mobile_Faq_Cancel_Subscription_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I cancel my Listening subscription?`)
};

const es_mobile_faq_cancel_subscription_question = /** @type {(inputs: Mobile_Faq_Cancel_Subscription_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo cancelo mi suscripción de Listening?`)
};

/**
* | output |
* | --- |
* | "How do I cancel my Listening subscription?" |
*
* @param {Mobile_Faq_Cancel_Subscription_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_cancel_subscription_question = /** @type {((inputs?: Mobile_Faq_Cancel_Subscription_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Cancel_Subscription_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_cancel_subscription_question(inputs)
	return en_mobile_faq_cancel_subscription_question(inputs)
});